export default __webpack_public_path__ + "static/media/ic_Parents.002a9a50.svg";